import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"

const hrefString = () => {
  // eslint-disable-next-line no-script-url
  return "javascript:googlefc.callbackQueue.push(googlefc.showRevocationMessage)"
}

const ManageConsent = ({ message }) => {
  const [href, setHref] = useState("")
  useEffect(() => {
    setHref(hrefString())
  }, [])
  return <a href={href}>{message}</a>
}

ManageConsent.defaultProps = {
  message: "Click here to revoke your choice",
}

ManageConsent.propTypes = {
  message: PropTypes.string,
}

export default ManageConsent
